module.exports = __webpack_public_path__ + "img/sixday1-1.ccd56fb4.jpg";